<template>
  <div class="relative" ref="menuContainer">
    <img
      src="/icons/projects/action-dots.svg"
      class="w-5 h-5 pointer-events-auto cursor-pointer"
      @click.stop="toggleMenu"
    />
    <div
      v-if="showMenu"
      class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg z-10"
    >
      <ul>
        <li
          @click="handleAction('View')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          View Project Details
        </li>
        <li
          v-if="user_type == 1"
          @click="handleAction('Assign')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          Assign Resources
        </li>
        <li
          v-if="user_type == 1"
          @click="handleAction('Add-Task')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          Add new task
        </li>
        <li
          v-if="user_type == 1"
          @click="handleAction('Edit')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          Edit Project
        </li>
        <li
          v-if="user_type == 1"
          @click="handleAction('Copy')"
          class="px-4 py-2 cursor-pointer hover:bg-gray-100"
        >
          Create empty copy
        </li>
        <li
          @click="handleAction('Delete')"
          class="px-4 py-2 cursor-pointer hover:bg-red-400 bg-red-200"
        >
          Delete project
        </li>
      </ul>
    </div>
    <ModalChangeStatus
      v-if="showModalChangeStatus"
      :isOpen="showModalChangeStatus"
      @close="showModalChangeStatus = false"
    />

    <AssignResources
      v-if="showAssignResources"
      :isOpen="showAssignResources"
      :projectId="item.id_project"
      @close="showAssignResources = false"
    />
    <CreateNewTask
      v-if="showModalCreateTask"
      :isOpen="showModalCreateTask"
      :projectId="item.id_project"
      :project_start="item.start_date"
      :project_end="item.due_date"
      @close="showModalCreateTask = false"
    />
    <ModalDelete
      v-if="showDeletedModal"
      :from="'project'"
      :item="item"
      :isOpen="showDeletedModal"
      @close="showDeletedModal = false"
    />
  </div>
</template>
    
    <script>
import { ref, onMounted, onUnmounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import menuState from "../../const/taskMenuState";
import ModalChangeStatus from "./Tasks/TaskEditStatus.vue";
import AssignResources from "../Projects/AssingResources.vue";
import CreateNewTask from "../Projects/Tasks/TaskCreateNewTask.vue";
import ModalDelete from "@/components/Projects/DeleteModal.vue";

export default {
  props: {
    item: Object,
  },
  components: {
    ModalChangeStatus,
    AssignResources,
    CreateNewTask,
    ModalDelete,
  },
  setup(props) {
    const router = useRouter();
    const store = useStore();
    const showMenu = ref(false);
    const showModalChangeStatus = ref(false);
    const showModalCreateTask = ref(false);
    const showModalTaskDetail = ref(false);
    const menuContainer = ref(null);
    const showAssignResources = ref(false);
    const user_type = computed(() => store.state.user.type);
    const showDeletedModal = ref(false);
    const isCopying = ref(false);

    const toggleMenu = () => {
      const newMenuState = !showMenu.value;
      menuState.setOpenMenuId(newMenuState ? props.item.id_project : null);
    };

    const handleAction = (action) => {
      if (action == "Change") {
        toggleModal();
      } else if (action == "View") {
        toggleProjectDetail();
      } else if (action == "Assign") {
        toggleModalAssign();
      } else if (action == "Add-Task") {
        toggleCreateTask();
      } else if (action == "Edit") {
        router.push({
          name: `edit-project`,
          params: { id: props.item.id_project },
        });
      } else if (action == "Delete") {
        toggleDeleteProject();
      } else if (action == "Copy") {
        copyProject();
      }

      showMenu.value = false;
      menuState.setOpenMenuId(null);
    };

    const handleClickOutside = (event) => {
      if (menuContainer.value && !menuContainer.value.contains(event.target)) {
        showMenu.value = false;
        menuState.setOpenMenuId(null);
      }
    };
    watch(
      () => menuState.getOpenMenuId(),
      (newId) => {
        showMenu.value = newId === props.item.id_project;
      }
    );

    onMounted(() => {
      document.addEventListener("click", handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener("click", handleClickOutside);
    });

    function toggleModal() {
      showModalChangeStatus.value = !showModalChangeStatus.value;
    }
    function toggleModalAssign() {
      showAssignResources.value = !showAssignResources.value;
    }
    function toggleCreateTask() {
      showModalCreateTask.value = !showModalCreateTask.value;
    }
    function toggleDeleteProject() {
      showDeletedModal.value = !showDeletedModal.value;
    }
    async function copyProject() {
      if (isCopying.value) return;
      isCopying.value = true;
      try {
        const response = await store.dispatch("copyProject", {
          id: props.item.id_project,
          changedBy: store.state.user.uid,
        });
        if (response.ok) {
          await store.dispatch("fetchTable", {
            page: 1,
            limit: 10,
            type: "projects",
          });
        }
      } finally {
        isCopying.value = false;
      }
    }
    async function toggleProjectDetail() {
      await store.commit("setSelectedProject", {
        id_project: props.item.id_project,
        name: props.item.name,
      });
      router.push({
        name: "project-details",
        params: { id: props.item.id_project },
      });
    }

    return {
      showMenu,
      toggleMenu,
      handleAction,
      showModalChangeStatus,
      showModalTaskDetail,
      menuContainer,
      showAssignResources,
      user_type,
      showModalCreateTask,
      showDeletedModal,
    };
  },
};
</script>
    
    <style scoped>
</style>
    